export default "I am footer. \"{{ element.value }}\" ";